import gsap from 'gsap';

export const prefersReducedMotion = (): boolean => {
  if (typeof window === 'undefined') return false;
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
};

export const animateFadeIn = (element: HTMLElement | null, delayMs: number = 0) => {
  if (!element || prefersReducedMotion()) return;
  gsap.fromTo(
    element,
    { opacity: 0, y: 8 },
    { opacity: 1, y: 0, duration: 0.25, delay: delayMs / 1000, ease: 'power2.out', clearProps: 'transform' }
  );
};

export const animateStaggerList = (elements: NodeListOf<Element> | Element[]) => {
  if (!elements || elements.length === 0 || prefersReducedMotion()) return;
  gsap.fromTo(
    elements,
    { opacity: 0, y: 6 },
    { opacity: 1, y: 0, duration: 0.2, stagger: 0.04, ease: 'power2.out' }
  );
};

export const animatePulseHighlight = (element: HTMLElement | null) => {
  if (!element || prefersReducedMotion()) return;
  gsap.fromTo(
    element,
    { scale: 0.98, opacity: 0.8 },
    { scale: 1, opacity: 1, duration: 0.3, ease: 'back.out(1.5)' }
  );
};
